import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { investmentDurationOptions2 } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
  selector: 'diversification-investment-project-duration',
  templateUrl: './diversification-investment-project-duration.component.html',
  styleUrls: ['./diversification-investment-project-duration.component.scss'],
  standalone: false,
})
export class DiversificationInvestmentProjectDurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  titresParticipatifsProjectDurationOptions = investmentDurationOptions2;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
